export const custodyRegistryVersion = "strategy-corpus-custody-0.1.0";

export const custodyStates = {
  LOCAL_HASHED_TEXT: "LOCAL_HASHED_TEXT",
  SOURCE_ANCHOR_ONLY: "SOURCE_ANCHOR_ONLY",
  LICENSED_BIBLIOGRAPHIC_ONLY: "LICENSED_BIBLIOGRAPHIC_ONLY",
  LOCAL_RESEARCH_INPUT_NOT_COUNTED: "LOCAL_RESEARCH_INPUT_NOT_COUNTED"
};

export const corpusCustodyRegistry = [
  {
    id: "custody-pg-sunzi-giles-1910",
    sourceId: "pg-sunzi-giles-1910",
    version: "1.0.0",
    custodyState: custodyStates.LOCAL_HASHED_TEXT,
    countable: true,
    sourceText: {
      path: "corpus/public-domain/art-of-war-giles-1910/pg132.txt",
      sha256: "c478f7e05a07bf190585fcea0bc4658ce22e47949ac18444eca53fb274878ffe",
      byteCount: 342105
    },
    derivedArtifacts: [
      {
        role: "public_domain_math_counts",
        path: "corpus/outputs/public-domain-math-counts.json",
        producedBy: "npm run extract:corpus"
      }
    ],
    chainBoundary:
      "Only this local Project Gutenberg file is countable. Other Sunzi translations are not counted by this custody record."
  },
  {
    id: "custody-pg-song-celestial-arnold-1900",
    sourceId: "pg-song-celestial-arnold-1900",
    version: "1.0.0",
    custodyState: custodyStates.LOCAL_HASHED_TEXT,
    countable: true,
    sourceText: {
      path: "corpus/public-domain/song-celestial-arnold-1885/pg2388.txt",
      sha256: "85b22401a9d256179f9a2e407215eb516da9b8213f23c32e03d66709d839a9e0",
      byteCount: 147501
    },
    derivedArtifacts: [
      {
        role: "public_domain_math_counts",
        path: "corpus/outputs/public-domain-math-counts.json",
        producedBy: "npm run extract:corpus"
      }
    ],
    chainBoundary:
      "Only this local Project Gutenberg Arnold translation file is countable. Other Bhagavad-Gita translations are not counted by this custody record."
  },
  {
    id: "custody-pg-tao-teh-king-legge-1891",
    sourceId: "pg-tao-teh-king-legge-1891",
    version: "1.0.0",
    custodyState: custodyStates.LOCAL_HASHED_TEXT,
    countable: true,
    sourceText: {
      path: "corpus/public-domain/tao-teh-king-legge-1891/pg216.txt",
      sha256: "041568f8dfef3ac6c2deb7699756f9d26d6aa8669647f4ce611b0ed4a95b0db6",
      byteCount: 80552
    },
    derivedArtifacts: [
      {
        role: "public_domain_math_counts",
        path: "corpus/outputs/public-domain-math-counts.json",
        producedBy: "npm run extract:corpus"
      }
    ],
    chainBoundary:
      "Only this local Project Gutenberg Legge Tao Teh King file is countable. Other Taoist texts and modern translations are not counted by this custody record."
  },
  {
    id: "custody-pg-dhammapada-muller-1881",
    sourceId: "pg-dhammapada-muller-1881",
    version: "1.0.0",
    custodyState: custodyStates.LOCAL_HASHED_TEXT,
    countable: true,
    sourceText: {
      path: "corpus/public-domain/dhammapada-muller-1881/pg2017.txt",
      sha256: "f2d09ebf28af0bf87ae7be7635d485b142e6526cb2cc164ba01c74586ff547bb",
      byteCount: 88619
    },
    derivedArtifacts: [
      {
        role: "public_domain_math_counts",
        path: "corpus/outputs/public-domain-math-counts.json",
        producedBy: "npm run extract:corpus"
      }
    ],
    chainBoundary:
      "Only this local Project Gutenberg Muller Dhammapada file is countable. Other Buddhist, Zen, Pali, or modern translations are not counted by this custody record."
  },
  {
    id: "custody-pg-bushido-nitobe-1908",
    sourceId: "pg-bushido-nitobe-1908",
    version: "1.0.0",
    custodyState: custodyStates.LOCAL_HASHED_TEXT,
    countable: true,
    sourceText: {
      path: "corpus/public-domain/bushido-nitobe-1908/pg12096.txt",
      sha256: "ceb5f526b47fa46bfa7fb9e8bcdec224d785f6d61b7793a086847af30369b8ed",
      byteCount: 224119
    },
    derivedArtifacts: [
      {
        role: "public_domain_math_counts",
        path: "corpus/outputs/public-domain-math-counts.json",
        producedBy: "npm run extract:corpus"
      }
    ],
    chainBoundary:
      "Only this local Project Gutenberg Nitobe Bushido file is countable. It is not a custody record for Musashi, Yagyu, or all Japanese martial strategy."
  },
  {
    id: "custody-pg-prince-machiavelli-marriott-1908",
    sourceId: "pg-prince-machiavelli-marriott-1908",
    version: "1.0.0",
    custodyState: custodyStates.LOCAL_HASHED_TEXT,
    countable: true,
    sourceText: {
      path: "corpus/public-domain/the-prince-machiavelli-marriott-1908/pg1232.txt",
      sha256: "f136e6c198b831dae14576cf67b81834b7a09c1e416a460a2a62973f3fd54b75",
      byteCount: 308022
    },
    derivedArtifacts: [
      {
        role: "public_domain_math_counts",
        path: "corpus/outputs/public-domain-math-counts.json",
        producedBy: "npm run extract:corpus"
      }
    ],
    chainBoundary:
      "Only this local Project Gutenberg Marriott Prince file is countable. It is not a custody record for all Machiavelli editions or political advice."
  },
  {
    id: "custody-pg-on-war-clausewitz-graham-1874",
    sourceId: "pg-on-war-clausewitz-graham-1874",
    version: "1.0.0",
    custodyState: custodyStates.LOCAL_HASHED_TEXT,
    countable: true,
    sourceText: {
      path: "corpus/public-domain/on-war-clausewitz-graham-1874/pg1946.txt",
      sha256: "c3ff450c013df060f3948d50a0b5162124b852a76f881845d2bf85e859b33d7b",
      byteCount: 1736560
    },
    derivedArtifacts: [
      {
        role: "public_domain_math_counts",
        path: "corpus/outputs/public-domain-math-counts.json",
        producedBy: "npm run extract:corpus"
      }
    ],
    chainBoundary:
      "Only this local Project Gutenberg Graham On War file is countable. It is not a custody record for all Clausewitz editions or military advice."
  },
  {
    id: "custody-pg-meditations-marcus-aurelius",
    sourceId: "pg-meditations-marcus-aurelius",
    version: "1.0.0",
    custodyState: custodyStates.LOCAL_HASHED_TEXT,
    countable: true,
    sourceText: {
      path: "corpus/public-domain/meditations-marcus-aurelius/pg2680.txt",
      sha256: "3ac9648961664c99e8bafe46224e16b08c1e67c9cb5f4c6da138b9d675028899",
      byteCount: 425308
    },
    derivedArtifacts: [
      {
        role: "public_domain_math_counts",
        path: "corpus/outputs/public-domain-math-counts.json",
        producedBy: "npm run extract:corpus"
      }
    ],
    chainBoundary:
      "Only this local Project Gutenberg Meditations file is countable. It is not a custody record for all Stoic texts, therapy claims, or spiritual authority."
  },
  {
    id: "custody-pg-leviathan-hobbes-1651",
    sourceId: "pg-leviathan-hobbes-1651",
    version: "1.0.0",
    custodyState: custodyStates.LOCAL_HASHED_TEXT,
    countable: true,
    sourceText: {
      path: "corpus/public-domain/leviathan-hobbes-1651/pg3207.txt",
      sha256: "3de1e492641d939567a8b0de827fb13e1ad992324f9ac8b204f60475009b7294",
      byteCount: 1254939
    },
    derivedArtifacts: [
      {
        role: "public_domain_math_counts",
        path: "corpus/outputs/public-domain-math-counts.json",
        producedBy: "npm run extract:corpus"
      }
    ],
    chainBoundary:
      "Only this local Project Gutenberg Leviathan file is countable. It is governance-risk context, not governance advice or political endorsement."
  },
  {
    id: "custody-ctext-sunzi",
    sourceId: "ctext-sunzi",
    version: "1.0.0",
    custodyState: custodyStates.SOURCE_ANCHOR_ONLY,
    countable: false,
    sourceText: null,
    derivedArtifacts: [],
    chainBoundary:
      "Chinese Text Project is an anchor for source mapping only until reuse terms and ingestion permissions are reviewed."
  },
  {
    id: "custody-ctext-seven-military-classics",
    sourceId: "ctext-seven-military-classics",
    version: "1.0.0",
    custodyState: custodyStates.SOURCE_ANCHOR_ONLY,
    countable: false,
    sourceText: null,
    derivedArtifacts: [],
    chainBoundary:
      "Seven Military Classics records are canonical inventory anchors only and are not counted corpus."
  },
  {
    id: "custody-ctext-guiguzi",
    sourceId: "ctext-guiguzi",
    version: "1.0.0",
    custodyState: custodyStates.SOURCE_ANCHOR_ONLY,
    countable: false,
    sourceText: null,
    derivedArtifacts: [],
    chainBoundary:
      "Guiguzi is source-anchor only; no bulk text ingestion or count claims are allowed from this record."
  },
  {
    id: "custody-ctext-i-ching",
    sourceId: "ctext-i-ching",
    version: "1.0.0",
    custodyState: custodyStates.SOURCE_ANCHOR_ONLY,
    countable: false,
    sourceText: null,
    derivedArtifacts: [],
    chainBoundary:
      "I Ching source-anchor records may support model design but not oracle, prediction, or count claims."
  },
  {
    id: "custody-shambhala-cleary-strategy-guide",
    sourceId: "shambhala-cleary-strategy-guide",
    version: "1.0.0",
    custodyState: custodyStates.LICENSED_BIBLIOGRAPHIC_ONLY,
    countable: false,
    sourceText: null,
    derivedArtifacts: [],
    chainBoundary:
      "Thomas Cleary strategy translations are licensed/bibliographic records only until lawful local text custody is supplied."
  },
  {
    id: "custody-shambhala-cleary-i-ching-guide",
    sourceId: "shambhala-cleary-i-ching-guide",
    version: "1.0.0",
    custodyState: custodyStates.LICENSED_BIBLIOGRAPHIC_ONLY,
    countable: false,
    sourceText: null,
    derivedArtifacts: [],
    chainBoundary:
      "Thomas Cleary I Ching translations are licensed/bibliographic records only and cannot be counted from this registry."
  },
  {
    id: "custody-recovered-glyph-cleary-audit",
    sourceId: "recovered-glyph-cleary-audit",
    version: "1.0.0",
    custodyState: custodyStates.LOCAL_RESEARCH_INPUT_NOT_COUNTED,
    countable: false,
    sourceText: {
      path: "/Users/abist-sovereignsystems/Documents/Glyph Forge/recovered/Genesis-Glyph-Forge/docs/CLEARY_AND_ANCIENT_CORPUS_MATH_AUDIT.md",
      sha256: "68f66a88f89a119dfa5c9fcad983fb09b7ddbb0b9593be1a967efca43bf9e22d",
      byteCount: 14925
    },
    derivedArtifacts: [],
    chainBoundary:
      "Recovered audit file is research input and claim-boundary evidence only; it is not counted ancient corpus."
  },
  {
    id: "custody-recovered-glyph-equation-registry",
    sourceId: "recovered-glyph-equation-registry",
    version: "1.0.0",
    custodyState: custodyStates.LOCAL_RESEARCH_INPUT_NOT_COUNTED,
    countable: false,
    sourceText: {
      path: "/Users/abist-sovereignsystems/Documents/Glyph Forge/recovered/Genesis-Glyph-Forge/docs/EQUATION_REGISTRY.md",
      sha256: "cb8479eff9f1fd192cf3cac2b510c7931d0b322add37b9a3b58c65a4f2a0db7b",
      byteCount: 7789
    },
    derivedArtifacts: [],
    chainBoundary:
      "Recovered equation registry is hashed research input for operator governance only; it is not counted source corpus or proof of formal equations."
  },
  {
    id: "custody-recovered-glyph-validation-sources",
    sourceId: "recovered-glyph-validation-sources",
    version: "1.0.0",
    custodyState: custodyStates.LOCAL_RESEARCH_INPUT_NOT_COUNTED,
    countable: false,
    sourceText: {
      path: "/Users/abist-sovereignsystems/Documents/Glyph Forge/recovered/Genesis-Glyph-Forge/docs/VALIDATION_SOURCES.md",
      sha256: "a63999d0bf49ddabf477b65595ae0646131b57843cd316dd96261b3f72f58d4d",
      byteCount: 4356
    },
    derivedArtifacts: [],
    chainBoundary:
      "Recovered validation-source file is hashed research input for source-boundary review only; it does not prove equations or validate predictive claims."
  }
];

export function custodySummary(registry = corpusCustodyRegistry) {
  return registry.reduce(
    (summary, record) => {
      summary.total += 1;
      summary[record.custodyState] = (summary[record.custodyState] ?? 0) + 1;
      if (record.countable) summary.countable += 1;
      return summary;
    },
    { total: 0, countable: 0 }
  );
}

export function custodyBySourceId(sourceId) {
  return corpusCustodyRegistry.find((record) => record.sourceId === sourceId);
}
